// Theme utility function - will be used with isDarkMode state
export const getThemeClasses = (isDarkMode, scrolled) => ({
  bg: isDarkMode ? 'bg-[#0c0a09]' : 'bg-white',
  text: isDarkMode ? 'text-stone-100' : 'text-stone-900',
  textMuted: isDarkMode ? 'text-stone-400' : 'text-stone-500',
  textSubtle: isDarkMode ? 'text-stone-500' : 'text-stone-400',
  border: isDarkMode ? 'border-stone-800' : 'border-stone-100',
  card: isDarkMode ? 'bg-[#141211]' : 'bg-stone-50',
  cardHover: isDarkMode ? 'hover:bg-[#1a1816]' : 'hover:bg-stone-50',
  btnPrimary: isDarkMode ? 'bg-stone-100 text-stone-900 hover:bg-white' : 'bg-stone-900 text-white hover:bg-stone-800',
  btnSecondary: isDarkMode ? 'bg-[#1c1917] text-stone-300 hover:bg-[#292524]' : 'bg-stone-100 text-stone-600 hover:bg-stone-200',
  nav: scrolled ? (isDarkMode ? 'bg-[#0c0a09]/90 border-b border-stone-800' : 'bg-white/90 border-b border-stone-100') : 'bg-transparent border-b border-transparent',
  input: isDarkMode ? 'bg-[#141211] border-stone-800 text-white focus:border-stone-400' : 'bg-white border-stone-200 text-stone-900 focus:border-stone-900'
});